import React, { useState } from "react";
import { LuChevronDown, LuChevronUp } from "react-icons/lu";

const TechsSection = ({ sections, mainTitle }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const displayData = sections || [];
  if (displayData.length === 0) return null;

  return (
    <div
      className="rounded-2xl border border-border-primary  backdrop-blur-md p-8! mt-10! mb-10! relative transition-all duration-300"
      style={{
        background: "var(--card-background)",
        boxShadow: "var(--card-shadow)",
      }}
    >
      <div className="flex flex-col gap-6!">
        {mainTitle && <h2 className="text-2xl font-bold text-text-primary">{mainTitle}</h2>}

        <div className="flex flex-col md:flex-row md:items-start justify-between gap-6! relative">
          <div className="flex-1">
            {!isExpanded ? (
              <div className="text-sm text-text-secondary leading-relaxed font-light line-clamp-2">{displayData[0].content}</div>
            ) : (
              <div className="flex flex-col gap-8! pb-12! animate-in fade-in duration-500">
                {displayData.map((item, index) => (
                  <div key={index} className="space-y-3!">
                    <h3 className="text-xl font-bold text-text-primary">{item.title}</h3>
                    <div className="text-sm text-text-secondary leading-relaxed font-light max-w-6xl">{item.content}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className={`shrink-0 flex items-center gap-1.5! text-xs font-semibold text-cyan-600 dark:text-cyan-400 border border-cyan-500/20 bg-cyan-500/5 hover:bg-cyan-500/10 dark:hover:bg-cyan-400/10 px-4! py-2! rounded-lg cursor-pointer transition-all hover:shadow-[0_0_10px_rgba(34,211,238,0.15)] 
              ${isExpanded ? "absolute bottom-0 right-0" : "self-center"}`}
          >
            <span>{isExpanded ? "Read Less" : "Read More"}</span>
            {isExpanded ? <LuChevronUp size={14} /> : <LuChevronDown size={14} />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TechsSection;
